module.exports = "https://cdn-static.kwai.net/kos/s101/nlav11312/shop/c_krn/krn-web/images/icon_kwai_gold.e4e6b9a2dc.png";